/**
 * 认证配置
 * 职责：用户认证相关配置
 */

export const AUTH_CONFIG = {
  // Token存储 - 与新功能系统保持一致
  TOKEN_KEY: 'auth_token',
  USER_INFO_KEY: 'foodlabel_user_info',

  // Token过期时间（小时）
  TOKEN_EXPIRE_HOURS: 24,

  // 记住登录
  REMEMBER_ME: true,
  REMEMBER_DAYS: 7,

  // 密码规则
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 20,
};

export default AUTH_CONFIG;

